import { render, staticRenderFns } from "./Portfolio-Popup.vue?vue&type=template&id=7aa70045&"
import script from "./Portfolio-Popup.vue?vue&type=script&lang=js&"
export * from "./Portfolio-Popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports